// PostHog wrapper. No-ops without a key (local/dev). EU host, autocapture off,
// pageviews on — mirrors apps/portal. Event names track the experiment rungs.
import posthog from 'posthog-js';

const KEY = import.meta.env.VITE_POSTHOG_KEY;

export function initAnalytics() {
  if (!KEY) return;
  posthog.init(KEY, {
    api_host: 'https://eu.i.posthog.com',
    capture_pageview: true,
    autocapture: false,
    persistence: 'localStorage',
  });
}

export function capture(event, props = {}) {
  if (!KEY) return;
  posthog.capture(event, props);
}

export function identify(userId) {
  if (!KEY) return;
  posthog.opt_in_capturing();
  posthog.identify(userId);
}

export function resetAnalytics() {
  if (!KEY) return;
  posthog.opt_out_capturing();
  posthog.reset();
}
